"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSearchResults = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const CreateFolderModal_style_1 = require("./CreateFolderModal.style");
const GroupSearchResult_1 = require("./GroupSearchResult");
exports.GroupSearchResults = (0, react_1.memo)(function GroupSearchResults({ groups, parentGroups, onSelected, }) {
    return ((0, jsx_runtime_1.jsx)(CreateFolderModal_style_1.StyledSearchResultsContainer, { children: groups.map((group) => ((0, jsx_runtime_1.jsx)(GroupSearchResult_1.GroupSearchResult, { group: group, parentGroups: parentGroups, onSelected: onSelected }, group.id))) }));
});
//# sourceMappingURL=GroupSeachResults.js.map